import React, { memo } from 'react'
import Radio from '@mui/material/Radio'
import FormLabel from '@mui/material/FormLabel'
import RadioGroup from '@mui/material/RadioGroup'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import { UserRightType } from '../../../../entities/User'
import Box from '@mui/material/Box'

interface RightProps {
	name: string
	right: string
	label: string
	handleRightChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
	disabled?: boolean
	hideRightWrite?: boolean
}

export const Right = memo((props: RightProps) => {
	const { label, name, handleRightChange, right, disabled, hideRightWrite } = props

	return (
		<FormControl
			sx={{ m: 0 }}
			variant="standard"
			disabled={!!disabled}
		>
			<Box display="flex" gap={2} alignItems="center">
				<FormLabel
					sx={{ pb: '0.5rem', width: '11rem' }}
					id={name}
				>
					{label}
				</FormLabel>
				<RadioGroup
					row
					name={name}
					aria-labelledby={name}
					defaultValue={UserRightType.NO_PERMISSION}
					value={right ?? UserRightType.NO_PERMISSION}
					onChange={handleRightChange}
					sx={{
						display: 'flex',
						gap: 6,
						flexWrap: 'nowrap'
					}}
				>
					<FormControlLabel
						value={UserRightType.NO_PERMISSION}
						label="No permission"
						labelPlacement="end"
						control={<Radio />}
					/>
					<FormControlLabel
						value={UserRightType.READ_ONLY}
						label="Read only"
						labelPlacement="end"
						control={<Radio />}
					/>
					<FormControlLabel
						value={UserRightType.WRITE}
						style={{ visibility: hideRightWrite ? 'hidden' : 'visible' }}
						label="Read & Write"
						labelPlacement="end"
						control={<Radio />}
					/>
				</RadioGroup>
			</Box>
		</FormControl>
	)
})
